<template>
  <div class="meeting-bill-edit">
    <el-container>
      <el-header style="background-color: white;">
        <el-button
          type="text"
          @click="showPolicy"
          style="float: right;position: relative;z-index: 100;"
          >查看政策说明</el-button
        >

        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息" name="first">
            <el-form
              ref="infoRef"
              :model="detail"
              label-width="100px"
              :inline="true"
              :rules="paymentApply ? rules11 : rules22"
              style="text-align: left;"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="提报部门：" prop="deptId">
                    <el-cascader
                      v-model="detail.deptId"
                      :props="cascaderProps"
                      :placeholder="
                        detail.deptName ? detail.deptName : '-请选择-'
                      "
                      ref="cascaderRef"
                    ></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="汇报人：" prop="reportUserName">
                    <!-- 汇报人，点击后弹框选择，这里的input只显示名字，不允许操作。 -->
                    <el-input
                      v-model="detail.reportUserName"
                      readonly
                    ></el-input>
                    <el-button @click="selectSubmitPerson" type="primary"
                      >选择</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="项目分类：" prop="projectType">
                    <el-select
                      v-model="detail.projectType"
                      placeholder="-请选择-"
                      @change="projectTypeChange"
                    >
                      <el-option
                        v-for="option in projectTypeList"
                        :key="option.id"
                        :label="option.value"
                        :value="option.label"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <el-button
                      type="primary"
                      @click="showTypeDesc"
                      style="margin-left: 20px"
                      >分类说明</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="会议议题：" prop="title">
                    <el-input
                      v-model="detail.title"
                      placeholder="-请输入-"
                      clearable
                      maxlength="100"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item prop="content">
                    <template slot="label">
                      <p style="display: inline-block;">主要内容：</p>
                      <!-- <p>(300字以内)</p> -->
                    </template>
                    <el-input
                      type="textarea"
                      v-model="detail.content"
                      placeholder="-请输入-"
                      clearable
                      :autosize="{ minRows: 8 }"
                      maxlength="2000"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="出席人：" prop="joinWorkList">
                    <div class="el-input tag-wrapper">
                      <el-tag
                        v-for="(tag, index) in detail.joinWorkList"
                        @close="closeJoinWork(tag)"
                        :key="index"
                        closable
                        style="margin-right: 5px;"
                        >{{ tag.displayName || tag.name }}</el-tag
                      >
                    </div>
                    <el-button @click="selectParticipanceList" type="primary"
                      >选择</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="参会部门：" prop="checkWorkList">
                    <div class="el-input tag-wrapper">
                      <el-tag
                        v-for="(tag, index) in detail.checkWorkList"
                        @close="closeCheckWork(tag)"
                        :key="index"
                        closable
                        style="margin-right: 5px;"
                        >{{ tag.name }}</el-tag
                      >
                    </div>
                    <el-button @click="selectAttendDepart" type="primary"
                      >选择</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="附件" name="second">
            <upLoadFileDialog
            :itemVOs="detail.declarationItemsVOs"
            @saveUpdateFile="saveUpdateFile"
            addoredit="true"
          ></upLoadFileDialog>
          </el-tab-pane>
          <el-tab-pane
            v-if="
              detail &&
                detail.projectType &&
                detail.projectType.indexOf('pay') > -1
            "
            label="付款申请"
            name="four"
            style="min-height: 500px;"
          >
            <!-- 选定工程款类型才能看到这个tab -->
            <el-form
              :model="applyFormData"
              label-width="120px"
              :inline="true"
              ref="applyFormRef"
              :rules="rules1"
            >
              <el-form-item label="项目部" prop="applyDeptId">
                <el-select
                  v-model="applyFormData.applyDeptId"
                  placeholder="请选择..."
                  clearable
                  @change="applyDeptIdChange"
                >
                  <el-option
                    v-for="dept in applyDeptList"
                    :key="dept.deptId"
                    :label="dept.deptName"
                    :value="dept.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="项目名称" prop="applyProjectId">
                <el-select
                  v-model="applyFormData.applyProjectId"
                  placeholder="请选择..."
                  clearable
                  @change="applyProjectIdChange"
                >
                  <el-option
                    v-for="project in applyProjectList"
                    :key="project.projectId"
                    :label="project.projectName"
                    :value="project.projectId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div class="table-header-flex">
              <span>所属年度:{{ applyDetailData.belongYear }}</span>
              <span>上报日期:{{ applyDetailData.createTime }}</span>
              <span>单位:元</span>
            </div>
            <div class="table-wrapper">
              <div v-if="applyDetailData" class="custom-table-header">
                <span class="thead-span"
                  >合同金额：{{
                    formatNumber(applyDetailData.contractAmount)
                  }}元</span
                >
                <span class="thead-span"
                  >工程收入：{{
                    formatNumber(applyDetailData.finishPriceSum)
                  }}元</span
                >
                <span class="thead-span"
                  >上报计量：{{
                    formatNumber(applyDetailData.calculatePriceSum)
                  }}元</span
                >
                <span class="thead-span"
                  >已收计量金额：{{
                    formatNumber(applyDetailData.receiptPriceSum)
                  }}元</span
                >
                <span class="thead-span"
                  >收集团拨款金额：{{
                    formatNumber(applyDetailData.groupAmount)
                  }}元</span
                >
              </div>
              <el-table
                :data="applyDetailTableData"
                border
                style="width: 100%;"
                :span-method="arraySpanMethod"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  fixed
                ></el-table-column>
                <el-table-column
                  prop="columnTitle"
                  label="项目"
                  width="150"
                  fixed
                ></el-table-column>
                <el-table-column
                  prop="partyB"
                  label="合作单位"
                  width="200"
                ></el-table-column>
                <el-table-column prop="numberList" label="合同编号" width="200">
                  <template slot-scope="scope">
                    <!-- <div
                      slot="content"
                      v-if="Array.isArray(scope.row.serialNumber)"
                    >
                      <p
                        v-for="item in scope.row.serialNumber"
                        :key="item"
                        style="margin-bottom: 0;min-width: 200px;"
                      >
                        {{ item }}
                      </p>
                    </div>
                    <div v-else>
                      <p style="margin-bottom: 0;min-width: 200px;">
                        {{ scope.row.serialNumber }}
                      </p>
                    </div> -->

                    <div class="number-list-wrapper">
                      {{ formatSerialNumber(scope.row.serialNumber) }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="contractContent"
                  label="合同内容"
                  width="200"
                ></el-table-column>
                <el-table-column label="税后合价" width="200">
                  <template slot-scope="scope">
                    <div>{{ formatNumber(scope.row.settleAmount) }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="累计已付款" width="200">
                  <template slot-scope="scope">
                    <div>{{ formatNumber(scope.row.alreadyPay) }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="尚欠款" width="200">
                  <template slot-scope="scope">
                    <div>{{ formatNumber(scope.row.debtAmount) }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="已付款比例" width="200">
                  <template slot-scope="scope">
                    <div>{{ formatPercent(scope.row.alreadyPayPct) }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="本次拟付款" width="200">
                  <template slot-scope="scope">
                    <div>{{ formatNumber(scope.row.thisPay) }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="再付款比例" width="200">
                  <template slot-scope="scope">
                    <div>{{ formatPercent(scope.row.thisPayPct) }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="remark"
                  label="备注"
                  width="200"
                ></el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="审批流程" name="third">
            <newApproveLine
            :addoredit="editFlag"
            :itemId="id"
            @saveApproveLine="saveApproveLine"
            @saveApproveType="saveApproveType"
            :approveType="approveType"
            :approveClass="approveClass"
            :subApproveType="detail.approveTemplateType || 'meetingbill'"
            :subApproveName="detail.approveTemplateName || ''"
          ></newApproveLine>
          </el-tab-pane>
          <div class="tabs-footer">
            <el-button type="primary" @click.stop="doSubmit(true)">暂存</el-button>
            <el-button type="primary" @click.stop="doSubmit(false)">提交</el-button>
            <el-button @click="closePage" type="info">取消</el-button>
          </div>
        </el-tabs>
      </el-header>
    </el-container>
    <select-dialog
      :visible="selectDialogVisible"
      @close="selectDialogClose"
      title="选择"
      v-bind="selectDialogOptions"
    />
    <el-dialog title="政策说明" :visible.sync="policyVisible">
      <div v-html="policyStr"></div>
      <div slot="footer" style="text-align: center;">
        <el-button type="primary" @click="policyVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="分类说明" :visible.sync="typeDescVisible">
      <div v-html="typeDescStr"></div>
      <div slot="footer" style="text-align: center;">
        <el-button type="primary" @click="typeDescVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSubService, getDeptCheck } from "@/services/departService";
import newApproveLine from "@/page/approveComponents/NewApproveLine"; //新增审批流程
import SelectDialog from "./SelectDialog";
import { formatMoney, formatPercent } from "../../finance/utils";
import Constants from "@/utils/consts";
import upLoadFileDialog from "@/components/upLoadFileDialog"; //上传附件

import {
  getDeclarationDetail,
  editDeclaration,
  getProjectTypeList,
  createApproveProcessService
} from "@/services/declarationServices";
import {
	updateApproveProcessStatusService,
} from "@/services/approveServices";
import {
  getDeptListService,
  getRuleDetailService,
} from "@/services/sysSettingService";
import {
  queryPayRequestInfoApi,
  earningCostqueryDeptListApi,
  earningCostqueryProjectListAPi
} from "@/services/financeService";
export default {
  name: "MeetingBillEdit",
  components: {
    upLoadFileDialog,
    SelectDialog,
    newApproveLine
  },
  data() {
    let validateReportPerson = (rule, value, callback) => {
      if (!value || !value.id) {
        return callback(new Error("汇报人不得为空"));
      }
      callback();
    };
    return {
      editFlag:true,
      approveType:'meetingbill',
      approveClass: "DECLARATION",
      flag:false,  //是否保存过审批流
      paymentApply: false,
      currentApplyDate: "",
      policyVisible: false,
      policyStr: "",
      typeDescVisible: false,
      typeDescStr: "",
      id: undefined,
      activeName: "first",
      detail: {
        // 详情的回包结构
        applyUserId: null,
        applyUserName: "",
        approveStatus: null,
        approveStatusName: "",
        checkWorkJson: "", // 参会部门
        checkWorkList: [],
        content: "", // 主要内容
        createTime: "",
        declarationItemsVOs: [], // 附件列表
        deptId: null, // 提报部门id
        deptName: "", // 提报部门
        id: null,
        // itemApproveProcessVOs: [], // 这里要注意，这里面有个status是99的，表示创建的人，它没有审批权。有他只是为了展示完整的生命链
        joinWorkJson: "", // 出席人
        joinWorkList: [],
        projectType: "", // 项目分类键
        projectTypeValue: "", // 项目分类的名
        reportUserId: null, // 汇报人id
        reportUserName: "", // 汇报人
        title: "", // 会议议题
        updateTime: ""
      },
      approveList: [],
      rules11: {
        deptId: [
          // 提报部门有问题：在创建的时候传的部门是最后一个，那在改的时候，就没法在打开的时候对应上
          { required: true, message: "请选择提报部门", trigger: "blur" }
        ],
        reportPerson: [
          { required: true, validator: validateReportPerson, trigger: "blur" }
        ],
        projectType: [
          { required: true, message: "请选择项目分类", trigger: "blur" }
        ]
      },
      rules22: {
        deptId: [
          // 提报部门有问题：在创建的时候传的部门是最后一个，那在改的时候，就没法在打开的时候对应上
          { required: true, message: "请选择提报部门", trigger: "blur" }
        ],
        reportPerson: [
          { required: true, validator: validateReportPerson, trigger: "blur" }
        ],
        projectType: [
          { required: true, message: "请选择项目分类", trigger: "blur" }
        ],
        title: [{ required: true, message: "请输入会议议题", trigger: "blur" }],
        content: [
          { required: true, message: "请输入主要内容", trigger: "blur" }
        ],
        joinWorkList: [
          {
            type: "array",
            required: true,
            message: "请选择出席人",
            trigger: ["blur", "change"]
          }
        ],
        checkWorkList: [
          {
            type: "array",
            required: true,
            message: "请选择参会部门",
            trigger: ["blur", "change"]
          }
        ]
      },
      rules1: {
        applyDeptId: [
          { required: true, message: "请选择项目部", trigger: "change" }
        ],
        applyProjectId: [
          { required: true, message: "请选择项目名称", trigger: "change" }
        ]
      },
      cascaderProps: {
        // 提报部门的选择
        checkStrictly: true,
        lazy: true,
        label: "name",
        value: "id",
        lazyLoad: (node, resolve) => {
          //  在这个加载方法里处理error，如果想用vue的this绑定，必须用箭头函数保持this指向。用function的写法会重新绑定this指向
          let { level } = node;
          if (level == 0) {
            // 第1级，用当前人的orgId去获取组织下的部门列表
            getDeptListService({
              pid: 0,
              orgId: sessionStorage.getItem("orgId") // 它这套打开的逻辑打乱了原有的生命周期，执行顺序，调用lazyLoad时还没有调用onActive
            })
              .then(res => {
                if (res.code == Constants.Code_OK) {
                  let nodes = res.data || [];
                  nodes.forEach(node => {
                    node.leaf = node.isLeaf == 1;
                  });
                  return resolve(nodes);
                } else if (res.code >= Constants.Code_Err) {
                  this.$alert(res.msg, "提示", {
                    confirmButtonText: "确定"
                  });
                } else {
                  this.$message.error(res.Msg);
                  resolve([]);
                }
              })
              .catch(error => {
                this.$message.error(Constants.Err_Msg);
                resolve([]);
              });
          } else {
            // 用选择的node去获取对应的子部门
            getSubService({
              deptId: node.data.id
            })
              .then(res => {
                if (res.code == Constants.Code_OK) {
                  let nodes = res.data || [];
                  nodes.forEach(node => {
                    node.leaf = node.isLeaf == 1;
                  });
                  return resolve(nodes);
                } else if (res.code >= Constants.Code_Err) {
                  this.$alert(res.msg, "提示", {
                    confirmButtonText: "确定"
                  });
                } else {
                  this.$message.error(res.Msg);
                  resolve([]);
                }
              })
              .catch(error => {
                this.$message.error(Constants.Err_Msg);
                resolve([]);
              });
          }
        }
      },
      projectTypeList: [], // 项目分类备选项
      selectDialogVisible: false,
      selectDialogOptions: {
        departOn: true,
        groupOn: true,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: false,
        maxSelectedItem: 1,
        dataKey: "reportPerson",
        canSelectAll: false
      },
      applyDeptList: [], // 供付款申请用的接口返回的备选项
      applyFormData: {}, // 付款申请表单
      applyProjectList: [], // 备选项
      applyDetailData: {}, // 选定的项目部和项目后的详情
      applyDetailTableData: [],
      isPaymentApply: false // 是否是付款申请
    };
  },
  watch: {
    "detail.deptId": function(newValue) {
      if (Array.isArray(newValue)) {
        // 修改的时候，没有给组件加clearable，所以这个提报部门肯定有值
        let dept = newValue[newValue.length - 1];
        getDeptCheck({ deptId: dept })
          .then(res => {
            if (res.code == Constants.Code_OK) {
              console.log("123", res.data);
              if (
                res.data.responseUserList &&
                res.data.responseUserList.length
              ) {
                let head = res.data.responseUserList[0];
                this.detail.reportUserId = head.id;
                this.detail.reportUserName = head.displayName || head.name;
              } else {
                // 没有部门负责人
                this.detail.reportUserId = undefined;
                this.detail.reportUserName = "";
              }
            } else {
              console.log(res.msg);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  },
  methods: {
    //存储审批流模板类型
    saveApproveType(item) {
      this.detail.approveTemplateType = item.label;
      this.detail.approveTemplateName = item.value;
    },
    //存储审批流
    saveApproveLine(selectItems,flag=false) {
      this.flag=flag
      this.approveList = selectItems;
    },
    formatSerialNumber(serialNumber) {
      if (!serialNumber) {
        return "";
      }
      if (Array.isArray(serialNumber)) {
        return serialNumber.join("、");
      }
      return serialNumber;
    },
    // 表格合并计算方法
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // || columnIndex == 3
      if (columnIndex == 1) {
        const {
          serviceCostAnalysis = [],
          materialCostAnalysis = [],
          machineCostAnalysis = [],
          otherDirectCostAnalysis = []
        } = this.applyDetailData;
        if (row.columnTitle == "劳务费") {
          let index = serviceCostAnalysis.indexOf(row);
          if (index == 0) {
            return {
              rowspan: serviceCostAnalysis.length,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        } else if (row.columnTitle == "材料费") {
          let index = materialCostAnalysis.indexOf(row);
          if (index == 0) {
            return {
              rowspan: materialCostAnalysis.length,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        } else if (row.columnTitle == "机械费") {
          let index = machineCostAnalysis.indexOf(row);
          if (index == 0) {
            return {
              rowspan: machineCostAnalysis.length,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        } else if (row.columnTitle == "其他直接费") {
          let index = otherDirectCostAnalysis.indexOf(row);
          if (index == 0) {
            return {
              rowspan: otherDirectCostAnalysis.length,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      }
    },
    showPolicy() {
      this.policyVisible = true;
    },
    initPolicy() {
      let businessType = "0003";
      getRuleDetailService(businessType)
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.policyStr = res.data.typeExplain;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        })
        .catch(error => {
          this.$message.error("系统异常");
        });
    },
    initTypeDesc() {
      let businessType = "0004";
      getRuleDetailService(businessType)
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.typeDescStr = res.data.typeExplain;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        })
        .catch(error => {
          this.$message.error("系统异常");
        });
    },

    closePage() {
      try {
        if (this.paymentApply) {
          this.bus.$emit("tabClose", "paymentApplyEdit");
          console.log("--付款申请");
          this.bus.$emit("navMenuChange", {
            routeId: "paymentApplyList"
          });
        } else {
          // 普通的提报单
          console.log("--提报单");
          this.bus.$emit("tabClose", "meetingBillEdit");
          this.bus.$emit("navMenuChange", {
            routeId: "meetingList"
          });
        }
      } catch (error) {}
    },
    onActive() {
      let params = this.tabRouteParam || {};
      this.activeName = "first";
      let { id, paymentApply } = params;
      this.paymentApply = paymentApply; // 进来时候是不是工程款
      setTimeout(() => {
        this.$refs.infoRef.clearValidate();
      }, 0);
      if (id) {
        this.id = id;
        this.getDetail()
          .then(() => {
            // 先获取详情，详情里有已经选定的审批人信息。
            // 再获取审批模板，匹配出不同的jobId，用来显示和后续的修改
            return this.initApproveList();
          })
          .catch(error => {
            console.log(error);
          });
      }

      this.initProjectTypeList();
      this.initPolicy();
      this.initTypeDesc();
      
    },

    initProjectTypeList() {
      getProjectTypeList()
        .then(res => {
          if (res.code == Constants.Code_OK) {
            //this.projectTypeList = res.data || [];
            if (res.data && res.data.length > 0) {
              if (this.paymentApply) {
                //付款申请页面，只显示工程款支付类型的项目分类，判断条件：label是否包含特征码'pay'
                this.projectTypeList = [];
                res.data.forEach(element => {
                  if (element.label.indexOf("pay") > -1) {
                    this.projectTypeList.push(element);
                  }
                });
              } else {
                this.projectTypeList = res.data;
              }
            } else {
              this.$alert(
                "尚未配置项目分类，请联系管理员，完成配置后重试！",
                "提示",
                {
                  confirmButtonText: "确定"
                }
              );
            }
          } else {
            this.$message.error(res.Msg);
          }
        })
        .catch(error => {
          this.$message.error(Constants.Err_Msg);
        });
    },

    getDetail() {
      // 进入页面，先去获取详情，展示以前的信息
      // 基本信息，附件，审批的人员都可以重新改
      return getDeclarationDetail({
        id: this.id
      })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            let data = res.data;
            try {
              data.checkWorkList = JSON.parse(data.checkWorkJson);
              data.joinWorkList = JSON.parse(data.joinWorkJson);
             
              this.detail = data;
              console.log("==--detail", data);

              this.applyFormData.applyDeptId = data.projectDeptId;
              this.applyFormData.applyProjectId = data.projectId;

              this.getApplyDeptList();
              this.getApplyProjectList();
              if (data.declarationPayRequestVO) {
                this.applyDetailData = data.declarationPayRequestVO || {};

                const {
                  serviceCostAnalysis = [],
                  materialCostAnalysis = [],
                  machineCostAnalysis = [],
                  otherDirectCostAnalysis = []
                } = this.applyDetailData;

                serviceCostAnalysis.forEach(item => {
                  item.columnTitle = "劳务费";
                });
                materialCostAnalysis.forEach(item => {
                  item.columnTitle = "材料费";
                });
                machineCostAnalysis.forEach(item => {
                  item.columnTitle = "机械费";
                });
                otherDirectCostAnalysis.forEach(item => {
                  item.columnTitle = "其他直接费";
                });

                let tableData = []
                  .concat(serviceCostAnalysis)
                  .concat(materialCostAnalysis)
                  .concat(machineCostAnalysis)
                  .concat(otherDirectCostAnalysis);

                this.applyDetailTableData = tableData;
              }

            } catch (error) {
              this.$message.error(error.message);
            }
          } else if (res.code >= Constants.Code_Err) {
            this.$alert(res.msg, "提示");
          } else {
            this.$alert(Constants.Err_Msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error.message || error, "提示");
        });
    },
    getApplyDeptList() {
      earningCostqueryDeptListApi()
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.applyDeptList = res.data || [];
          }
        })
        .catch(() => {});
    },
    getApplyProjectList() {
      if (this.applyFormData.applyDeptId) {
        earningCostqueryProjectListAPi({
          deptId: this.applyFormData.applyDeptId
        })
          .then(res => {
            if (res.code == Constants.Code_OK) {
              this.applyProjectList = res.data || [];
            }
          })
          .catch(() => {});
      }
    },
    getApplyDetailData() {
      if (!this.applyFormData.applyProjectId) {
        return;
      }
      queryPayRequestInfoApi({
        projectId: this.applyFormData.applyProjectId
      })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.applyDetailData = res.data || {};
            const {
              serviceCostAnalysis = [],
              materialCostAnalysis = [],
              machineCostAnalysis = [],
              otherDirectCostAnalysis = []
            } = this.applyDetailData;

            serviceCostAnalysis.forEach(item => {
              item.columnTitle = "劳务费";
            });
            materialCostAnalysis.forEach(item => {
              item.columnTitle = "材料费";
            });
            machineCostAnalysis.forEach(item => {
              item.columnTitle = "机械费";
            });
            otherDirectCostAnalysis.forEach(item => {
              item.columnTitle = "其他直接费";
            });

            let tableData = []
              .concat(serviceCostAnalysis)
              .concat(materialCostAnalysis)
              .concat(machineCostAnalysis)
              .concat(otherDirectCostAnalysis);

            this.applyDetailTableData = tableData;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error.message, "提示");
        });
    },
    applyDeptIdChange(value) {
      console.log("----", value, this.applyFormData.applyDeptId);
      //项目部变了之后，能选的项目名称也要变，所以要重新调用接口
      this.applyFormData.applyProjectId = undefined;
      this.applyDetailData = {};
      this.applyDetailTableData = [];
      this.getApplyProjectList();
    },
    applyProjectIdChange() {
      if (!this.applyFormData.applyProjectId) {
        return;
      }
      queryPayRequestInfoApi({
        projectId: this.applyFormData.applyProjectId
      })
        .then(res => {
          if (res.code == Constants.Code_OK) {
            this.applyDetailData = res.data || {};
            const {
              serviceCostAnalysis = [],
              materialCostAnalysis = [],
              machineCostAnalysis = [],
              otherDirectCostAnalysis = []
            } = this.applyDetailData;

            serviceCostAnalysis.forEach(item => {
              item.columnTitle = "劳务费";
            });
            materialCostAnalysis.forEach(item => {
              item.columnTitle = "材料费";
            });
            machineCostAnalysis.forEach(item => {
              item.columnTitle = "机械费";
            });
            otherDirectCostAnalysis.forEach(item => {
              item.columnTitle = "其他直接费";
            });

            let tableData = []
              .concat(serviceCostAnalysis)
              .concat(materialCostAnalysis)
              .concat(machineCostAnalysis)
              .concat(otherDirectCostAnalysis);

            this.applyDetailTableData = tableData;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          this.$alert(error.message, "提示");
        });
    },
    formatNumber: formatMoney,
    formatPercent: formatPercent,
    saveUpdateFile(files) {
      // 附件tab里确定好文件列表了.删除和新加的时候，都会发出这个submit事件
      this.detail.declarationItemsVOs = files;
    },

    projectTypeChange(type) {
      console.log("当前选择的type");
      // this.approveList = [];
      // this.refreshApproveList();
    },

    showTypeDesc() {
      this.typeDescVisible = true;
    },
    selectSubmitPerson() {
      // 选择汇报人
      this.selectDialogOptions = {
        departOn: true,
        groupOn: true,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: false,
        maxSelectedItem: 1,
        dataKey: "reportPerson",
        canSelectAll: false
      };
      this.selectDialogVisible = true;
    },
    selectParticipanceList() {
      // 选择出席人.可以选择个人，可以选择群组，不可以选择部门
      this.selectDialogOptions = {
        departOn: true,
        groupOn: true,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: true,
        maxSelectedItem: 0,
        dataKey: "participance"
      };
      this.selectDialogVisible = true;
    },
    selectAttendDepart() {
      // 选择参会部门
      this.selectDialogOptions = {
        departOn: true,
        groupOn: false,
        canSelectDepart: true,
        canSelectUser: false,
        canSelectGroup: false,
        maxSelectedItem: 0,
        dataKey: "attendDepart"
      };
      this.selectDialogVisible = true;
    },
    selectDialogClose(data) {
      console.log("111 selectDialogClose ----", data);
      this.selectDialogVisible = false;
      const { dataKey } = data;
      switch (dataKey) {
        case "reportPerson": // 汇报人
          if (data.userList && data.userList.length > 0) {
            let vo = data.userList[0];
            this.detail.reportUserId = vo.id;
            this.detail.reportUserName = vo.displayName || vo.name;
          }
          break;
        case "attendDepart": // 参会部门
          // eslint-disable-next-line
          let checkWorkList = this.detail.checkWorkList;
          // eslint-disable-next-line
          let addList = data.departList || [];
          addList.forEach(item => {
            let index = checkWorkList.findIndex(work => work.id == item.id);
            if (index == -1) {
              checkWorkList.push(item);
            }
          });
          break;
        case "participance": // 出席人
          // eslint-disable-next-line
          let userList = data.userList || [];
          // eslint-disable-next-line
          let groupList = data.groupList || [];
          userList.forEach(user => {
            user.meetingType = "user";
          });
          groupList.forEach(group => {
            group.meetingType = "group";
          });
          // eslint-disable-next-line
          let allList = userList.concat(groupList);
          // eslint-disable-next-line
          let joinWorkList = this.detail.joinWorkList;

          allList.forEach(item => {
            let index = joinWorkList.findIndex(
              work => work.id == item.id && work.meetingType == item.meetingType
            );
            if (index == -1) {
              joinWorkList.push(item);
            }
          });
          break;

        default:
          break;
      }
    },

    closeJoinWork(data) {
      // 出席人
      console.log("--出席人", data);
      let index = this.detail.joinWorkList.findIndex(
        work => work.id == data.id && work.meetingType == data.meetingType
      );
      if (index >= 0) {
        this.detail.joinWorkList.splice(index, 1);
      }
    },
    closeCheckWork(data) {
      // 参会部门
      console.log("- delete 参会部门", data);
      let index = this.detail.checkWorkList.findIndex(
        work => work.id == data.id
      );
      if (index >= 0) {
        this.detail.checkWorkList.splice(index, 1);
      }
    },

    doSubmit(val) {
      let infoPromise = new Promise((resolve, reject) => {
        this.$refs.infoRef.validate(valid => {
          if (valid == false) {
            reject(false);
          } else {
            resolve(true);
          }
        });
      });

      let approvePromise = new Promise((resolve, reject) => {
        let pass = true;
        if (this.approveList.length == 0 && !val) {
          // 如果approveList长度是0，那代表还没有选定项目类型，从而获取审批流
          this.$message.warning("请配置审批流程");
          reject(false);
        }
        for (let i = 0; i < this.approveList.length; i++) {
          if (!!this.approveList[i].approveUserId == false) {
            // 还没选定人
            pass = false;
            break;
          }
        }

        if (pass == false && !val) {
          this.$message.warning("请配置审批流程");
          reject(false);
        } else {
          resolve(true);
        }
      });

      Promise.all([approvePromise, infoPromise])
        .then(() => {
          console.log("通过全部验证");

          let { deptId } = this.detail;
          if (Array.isArray(deptId)) {
            deptId = deptId.length > 0 ? deptId[deptId.length - 1] : undefined;
          }
          this.detail.checkWorkJson = JSON.stringify(this.detail.checkWorkList);
          this.detail.joinWorkJson = JSON.stringify(this.detail.joinWorkList);

          let params = {
            isTempSave: val,
            id: this.detail.id,
            checkWorkJson: this.detail.checkWorkJson, // 参会部门
            content: this.detail.content, // 主要内容
            declarationItemsVOs: this.detail.declarationItemsVOs, // 附件列表
            deptId: deptId, // 提报部门
            // itemApproveProcessVOs: this.detail.itemApproveProcessVOs, // 审批流
            joinWorkJson: this.detail.joinWorkJson, // 出席人
            projectType: this.detail.projectType, // 项目分类
            reportUserId: this.detail.reportUserId, // 汇报人id
            title: this.detail.title, // 会议议题
            approveStatus: this.detail.approveStatus, // 原来的审核状态
            approveTemplateType: this.detail.approveTemplateType,
            approveTemplateName: this.detail.approveTemplateName,
          };
          return params;
        })
        .then(params => {
          console.log("项目分类", params.projectType);
          if (params.projectType.indexOf("pay") == -1) {
            return editDeclaration(params);
          }
          // 是工程款支付类型
          console.log("是工程款支付类型");
          if (
            !this.applyFormData ||
            !this.applyFormData.applyDeptId ||
            !this.applyFormData.applyProjectId
          ) {
            this.$message.warning("请设置付款申请信息");
            return Promise.reject("请设置付款申请信息");
          }

          params.projectDeptId = this.applyFormData.applyDeptId;
          params.projectId = this.applyFormData.applyProjectId;
          return editDeclaration(params);
        })
        .then(res => {
          console.log('---更新回来', res);

          if (res.code == Constants.Code_OK) {
            if (val) {
              this.tempSaveContent(this.detail.id);
              return;
            }
            let itemName = ""
            let type = this.detail.projectType
            if(type.indexOf("pay") == -1) {
              // 普通的会议提报
              let deptName = this.detail.deptName; // 这里为了防止意外报错
              try {
                let checkedNodes = this.$refs.cascaderRef.getCheckedNodes(true);
                let node = checkedNodes[checkedNodes.length - 1];
                deptName = node.pathLabels[node.pathLabels.length - 1];
              } catch (error) {
                console.log(error);
              }
              
              itemName = `${sessionStorage.getItem("name")}关于${deptName}${this.detail.title}的${this.detail.approveTemplateName?this.detail.approveTemplateName:'会议提报'}申请`
            } else {
              // 付款申请
              let danwei = new Set()
              let tableData = this.applyDetailTableData||[]
              for(let i=0;i<tableData.length;i++) {
                danwei.add(tableData[i].partyB)
              }
              danwei = Array.from(danwei)
              danwei = danwei.join("、")
              itemName = `${sessionStorage.getItem("name")}关于${this.applyDetailData.belongYear}${danwei}的${this.detail.approveTemplateName?this.detail.approveTemplateName: "工程款支付"}申请`
            }

            let params = {
              approveClass: "DECLARATION",
              approveProcessDtoList: this.approveList,
              itemId: this.id,
              approveStatusEnum: "UNDERAPLLY",
              itemName,
              projectId: this.applyFormData ? this.applyFormData.applyProjectId : null
            };
            let apiName=this.flag?updateApproveProcessStatusService:createApproveProcessService
            apiName(params).then(res => {
              console.log("---创建审批流回来", res);
              if (res.code == Constants.Code_OK) {
                this.$alert(Constants.Add_OK_Msg, "提示");
                this.closePage();
              } else if (res.code == Constants.Code_Err) {
                this.$alert(res.msg, "提示");
              } else {
                this.$alert(Constants.Err_Msg, "提示");
              }
            });
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //暂存审批流
    tempSaveContent(itemId) {
      if (this.approveList.length == 0) {
        this.$message.success("保存成功", "提示");
        // 如果approveList长度是0，那代表还没有选定项目类型，暂存不保存审批流
        this.closePage();
        return
      }
      let pass=true;
      for (let i = 0; i < this.approveList.length; i++) {
        if (!this.approveList[i].approveUserId) {
          // 还没选定人
          pass = false;
          break;
        }
      }
      //未选择审批人，不保存审批流
      if (pass == false) {
        this.$message.success("保存成功", "提示");
        this.closePage();
        return
      }
      let itemName = ""
            let type = this.detail.projectType
            if(type.indexOf("pay") == -1) {
              // 普通的会议提报
              let deptName = this.detail.deptName; // 这里为了防止意外报错
              try {
                let checkedNodes = this.$refs.cascaderRef.getCheckedNodes(true);
                let node = checkedNodes[checkedNodes.length - 1];
                deptName = node.pathLabels[node.pathLabels.length - 1];
              } catch (error) {
                console.log(error);
              }
              
              itemName = `${sessionStorage.getItem("name")}关于${deptName}${this.detail.title}的${this.detail.approveTemplateName||'会议提报'}申请`
            } else {
              // 付款申请
              let danwei = new Set()
              let tableData = this.applyDetailTableData||[]
              for(let i=0;i<tableData.length;i++) {
                danwei.add(tableData[i].partyB)
              }
              danwei = Array.from(danwei)
              danwei = danwei.join("、")
              itemName = `${sessionStorage.getItem("name")}关于${this.applyDetailData.belongYear}${danwei}的${this.detail.approveTemplateName|| "工程款支付"}申请`
            }

            let params = {
              approveClass: "DECLARATION",
              approveProcessDtoList: this.approveList,
              itemId: this.id,
              approveStatusEnum: "READY",
              itemName,
              projectId: this.applyFormData ? this.applyFormData.applyProjectId : null
            };

            createApproveProcessService(params).then(res => {
              if (res.code == Constants.Code_OK) {
                this.$alert(Constants.Add_OK_Msg, "提示");
                this.closePage();
              } else if (res.code == Constants.Code_Err) {
                this.$alert(res.msg, "提示");
              } else {
                this.$alert(Constants.Err_Msg, "提示");
              }
            })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";

.meeting-bill-edit {
  height: 100%;
    /deep/.el-select{
    width: 600px;
  }
}

.el-tab-pane {
  margin-top: 20px;
}

/deep/ .el-tabs__item {
  padding: 0 20px !important;
}
/deep/ .el-tabs__header {
  padding-right: 0px !important;
}

/deep/ .el-form-item__content {
  display: flex;

  .el-input {
    flex: 1;
  }

  .el-button {
    margin-left: 10px;
    height: fit-content;
  }
}

.tag-wrapper {
  border: 1px solid #dcdfe6;
  padding: 0 5px;
}

/deep/ .el-tab-pane {
  min-height: 500px !important;
}

.approve-btns {
  text-align: center;
  margin-top: 20px;
}

.tabs-footer {
  text-align: center;
  padding: 50px 0 20px;
}

.table-header-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.custom-table-header {
  position: relative;
  width: 100%;
  padding: 20px 10px;
  background: #edf8fa;
  border-bottom: 1px solid #ebeef5;

  .thead-span {
    margin-right: 20px;
  }
}
</style>
